import { isCreateOperation } from '../utils/eventHandlerUtil';
import { applyAdjDispositionToOrder, hasAdjDisposition } from '../utils/adjDisposition';

// Utility for submitUsageOrder logic
const submitUsageOrderUtil = ({
    reportPaymentRequestObj,
    orderLockData,
    setShowSurgeryNonUsePopup,
    usageDetails,
    reportUsageFormObj,
    getPriceInNumberDataType,
    notes,
    dispatch,
    createUsageOrderRequest,
    updateUsageOrderRequest,
    myCaseResourceType,
    setLockLoader,
    showReportPayment,
    storeUsageDataPresist,
    setEmails,
    emailInputBoxes,
    setEmailInputBoxes,
    validateEmail,
    t,
    vendorCaseId,
    discrepancyAttachment,
    pediatricSurgery,
    pediatricCheck,
    setSubmitClicked,
    discrepencyUpdatedDetails,
    storedItemTableData,
    orderStatusDescription,
    adjustmentDisEnabled
}) => {
    setShowSurgeryNonUsePopup(false);
    var tissueAndNonTissueItemsInSurgery =
        usageDetails?.tissueAndNonTissueItemsInSurgery &&
        reportUsageFormObj.products?.length > 0 &&
        !(
            reportUsageFormObj.products.some((item) => item.salesOrg === 'S002') &&
            reportUsageFormObj.products.some((item) => item.salesOrg === 'S030')
        );
    let tempReplenNote = [];
    let tempUsageNote = [];

    let replNote = notes?.reportReplenishmentNotes;
    replNote?.length > 0 &&
        replNote.map((it) => {
            tempReplenNote.push({
                creationDate: it.creationDate,
                note: it.note,
                typeOfNote: it.typeOfNote,
                userName: it.userName,
                statusOfSEOrder: it.statusOfSEOrder ? it.statusOfSEOrder : '',
            });
        });
    let usageNote = notes?.reportUsageNotes;
    usageNote?.length > 0 &&
        usageNote.map((it) => {
            tempUsageNote.push({
                creationDate: it.creationDate,
                note: it.note,
                typeOfNote: it.typeOfNote,
                userName: it.userName,
                statusOfSEOrder: it.statusOfSEOrder ? it.statusOfSEOrder : '',
            });
        });

    let tempUsageAdjNote = [];
    let usageAdjNote = notes?.reportUsageAdjNotes;
    usageAdjNote?.length > 0 &&
        usageAdjNote.map((it) => {
            tempUsageAdjNote.push({
                creationDate: it.creationDate,
                note: it.note,
                typeOfNote: it.typeOfNote,
                userName: it.userName,
                statusOfSEOrder: it.statusOfSEOrder ? it.statusOfSEOrder : '',
            });
        });
    // Adj notes are sent only when adj is enabled and an adj qty was reported.
    const sendUsageAdjNotes =
        adjustmentDisEnabled && hasAdjDisposition(reportUsageFormObj?.products);

    let reportUsageSubmissionObj = {
        ...reportUsageFormObj,
        isSapSubmission: true,
        isAdditionalUsage: myCaseResourceType === 'additionalUsage',
        usagecustomerNotes: tempUsageNote,
        usageAdjcustomerNotes: sendUsageAdjNotes ? tempUsageAdjNote : [],
        usageReplenishmentcustomerNotes: tempReplenNote,
    };
    reportUsageSubmissionObj.isChangeAccount =
        usageDetails?.changeAccountEnabled || false;
    if (usageDetails?.changeAccountEnabled) {
        reportUsageSubmissionObj.updatedZLBAccount =
            usageDetails?.accountId || usageDetails?.originalAccountId;
    }
    if (
        myCaseResourceType !== 'reportPayment' &&
        reportUsageSubmissionObj.products?.length > 0
    ) {
        reportUsageSubmissionObj.products =
            reportUsageSubmissionObj.products.map((item) => ({
                ...item,
                isAdditionalCartEntry: false,
                unitPrice: item.isAccountOwned
                    ? '0.00'
                    : getPriceInNumberDataType(item.unitPrice)?.toFixed(2),
            }));
    }

    if (discrepencyUpdatedDetails?.discrepancyExists) {
        const storedItemProduct = [...storedItemTableData];
        reportUsageSubmissionObj.products =
            reportUsageSubmissionObj.products.map((item) => {
                const temp = storedItemProduct.filter(
                    (x) =>
                        (x.cfn === item.productCFN ||
                            x.productCFN === item.productCFN ||
                            x.cfn === item.cfn ||
                            x.productCFN === item.cfn) &&
                        item.unqId === x.unqId
                );
                return {
                    ...item,
                    useMadeAccountOwned:
                        item.isAccountOwned === temp[0]?.userMadeAccountOwned
                            ? false
                            : true,
                };
            });
        if (emailInputBoxes.length > 0) {
            const checkNonEmptyEmailLists =
                emailInputBoxes.length >= 1
                    ? emailInputBoxes.filter((x) => x.value !== '').length > 0
                        ? true
                        : false
                    : false;

            emailInputBoxes && emailInputBoxes?.length
                ? emailInputBoxes.length >= 1 && checkNonEmptyEmailLists
                    ? emailInputBoxes.map((emails) => {
                          if (emails && emails.value) {
                              if (!validateEmail(emails.value)) {
                                  emails.errorMessage = t(
                                      'orders.reportsAndInvoice.viewReport.reqinvoice'
                                  );
                              } else {
                                  emails.errorMessage = '';
                              }
                          } else {
                              emails.errorMessage = '';
                          }

                          return { ...emails };
                      })
                    : emailInputBoxes.map((emails, index) => {
                          if (index === 0) {
                              if (!validateEmail(emails.value)) {
                                  emails.errorMessage = t(
                                      'orders.reportsAndInvoice.viewReport.reqinvoice'
                                  );
                              } else {
                                  emails.errorMessage = '';
                              }
                          }

                          return { ...emails };
                      })
                : null;

            setEmailInputBoxes([...emailInputBoxes]);
            const checkValid =
                emailInputBoxes.filter((x) => x.errorMessage !== '').length > 0;

            const validEmailAddress = emailInputBoxes.filter(
                (x) => x.value !== '' && x.errorMessage == ''
            );

            //comma seprated list
            const emailIdsObj = validEmailAddress?.map((x) => x?.value);
            if (emailIdsObj?.length > 0) {
                setEmails(emailIdsObj);
            }

            const usageSEDiscrepancy = {
                discrepancyExists: true,
                discrepancyDto: {
                    emailIds: emailIdsObj?.toString(),
                    uploadedFileNames: discrepancyAttachment.toString(),
                },
            };
            if (!checkValid && checkNonEmptyEmailLists) {
                reportUsageSubmissionObj.vendorCaseId = vendorCaseId;
                reportUsageSubmissionObj.usageSEDiscrepancy = usageSEDiscrepancy;
                //api call for discrepancy submit
                const isCreate = isCreateOperation(myCaseResourceType, orderStatusDescription, t);
                dispatch(
                    isCreate
                        ? createUsageOrderRequest(applyAdjDispositionToOrder(reportUsageSubmissionObj, adjustmentDisEnabled), 'submit')
                        : updateUsageOrderRequest(applyAdjDispositionToOrder(reportUsageSubmissionObj, adjustmentDisEnabled), 'submit')
                );
                if (tissueAndNonTissueItemsInSurgery) {
                    dispatch(setSubmitClicked(true));
                }
                if (
                    !tissueAndNonTissueItemsInSurgery &&
                    myCaseResourceType !== 'reportPayment' &&
                    Object.prototype.hasOwnProperty.call(
                        orderLockData,
                        'isOrderLocked'
                    ) &&
                    !orderLockData?.loader
                ) {
                    dispatch(setSubmitClicked(true));
                }
            }
        }
        if (
            !tissueAndNonTissueItemsInSurgery &&
            myCaseResourceType !== 'reportPayment' &&
            Object.prototype.hasOwnProperty.call(
                orderLockData,
                'isOrderLocked'
            ) &&
            !orderLockData?.loader
        ) {
            setLockLoader(orderLockData?.loader);
        }
    } else {
        if (myCaseResourceType === 'reportPayment') {
            setLockLoader(false);
        }
        if (showReportPayment) {
            dispatch(
                storeUsageDataPresist({
                    name: 'reportPayment',
                    value: [],
                })
            );
            dispatch(
                storeUsageDataPresist({
                    name: 'showReportPayment',
                    value: false,
                })
            );
        }

        const reportPaymentSubmissionObj = {
            ...reportPaymentRequestObj,
            isAdditionalUsage: myCaseResourceType === 'additionalUsage',
            usagecustomerNotes: tempUsageNote,
            usageReplenishmentcustomerNotes: tempReplenNote,
        };
        // !infoBanner?.length>0 || !confirmationBanner?.length>0 &&
        if (
            myCaseResourceType === 'reportPayment' &&
            reportPaymentSubmissionObj?.procedure
        ) {
            delete reportPaymentSubmissionObj?.procedure;
        }
        if (
            pediatricSurgery &&
            pediatricCheck !== '' &&
            pediatricCheck !== undefined
        ) {
            reportPaymentSubmissionObj.pediatricSurgery = pediatricCheck;
        }
        const isCreate = isCreateOperation(myCaseResourceType, orderStatusDescription, t);
        const submissionPayload = applyAdjDispositionToOrder(
            myCaseResourceType !== 'reportPayment'
                ? reportUsageSubmissionObj
                : reportPaymentSubmissionObj,
            adjustmentDisEnabled
        );
        dispatch(
            isCreate
                ? createUsageOrderRequest(submissionPayload, 'submit')
                : updateUsageOrderRequest(submissionPayload, 'submit')
        );
        // setLockLoader(false);
        if (tissueAndNonTissueItemsInSurgery) {
            dispatch(setSubmitClicked(true));
        }
        if (
            !tissueAndNonTissueItemsInSurgery &&
            myCaseResourceType !== 'reportPayment' &&
            Object.prototype.hasOwnProperty.call(
                orderLockData,
                'isOrderLocked'
            ) &&
            !orderLockData?.loader
        ) {
            setLockLoader(orderLockData?.loader);
            dispatch(setSubmitClicked(true));
        }
    }
};

export default submitUsageOrderUtil;
